var map = {
	"./403.svg": "qCdb",
	"./404.svg": "0xLf",
	"./500.svg": "5KHa",
	"./logoFull.svg": "vHcX",
	"./logoText.svg": "g9AA"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UKcq";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\.svg$
// module id = UKcq
// module chunks = 1